
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {PartnerContactModel} from '../../../api/model/partnerContact.model';
import {PartnerContactConverter} from '../../../api/model/converter/partnerContact.converter';

@Injectable({
    providedIn: 'root'
})
export class PartnerContactDataservice extends AbstractDataServiceV2<PartnerContactModel, PartnerContactConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PartnerContactConverter) {
        super('PartnerContact', http, httpUrlGenerator, logger, config, converter);
    }
}
